import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { Button } from '@farewill/ui'

import OwnerAssignmentDropdown from 'components/owner-assignment-dropdown'
import useApiHelpers from 'lib/effects/api-helpers'

const StyledBulkAssignButton = styled(Button.Underline)`
  padding: 0;
`

export type BulkAssignDropdownProps = {
  selectedLeadIds: number[]
  loggedInAdminUserId: number
  onAssigned: () => void
}

const BulkAssignDropdown = ({
  selectedLeadIds,
  loggedInAdminUserId,
  onAssigned,
}: BulkAssignDropdownProps) => {
  const cache = useQueryClient()

  const { createItem: bulkAssign, isCreating: isCreatingBulkAssign } =
    useApiHelpers({
      baseUrl: `/api/lead-events/bulk-assign`,
      type: 'lead_events_bulk_assign',
    })
  const handleBulkAssign = async (adminUserId: number | null) => {
    if (adminUserId == null) return

    const bulkAssignResponse = await bulkAssign({
      leadIds: selectedLeadIds,
      adminUserId,
    })
    const assignedLeadCount =
      bulkAssignResponse?.attributes?.assignedLeadIds?.length ?? 0
    cache.invalidateQueries('leads')
    onAssigned()
    toast(
      `${assignedLeadCount} lead${
        assignedLeadCount === 1 ? '' : 's'
      } assigned.`,
      { toastId: 'bulk-lead-assigned' }
    )
  }

  return (
    <OwnerAssignmentDropdown
      alignment="right"
      loggedInAdminUserId={loggedInAdminUserId}
      isSubmitting={isCreatingBulkAssign}
      header={`${selectedLeadIds.length} leads selected`}
      onAssign={handleBulkAssign}
      trigger={
        <StyledBulkAssignButton type="button">
          Bulk assign
        </StyledBulkAssignButton>
      }
    />
  )
}

export default BulkAssignDropdown
